<div class="add-invoice-border">
  <div class="add-invoice">
    <div class="add-invoice-left">
      <div class="add-invoice-left-bar"></div>
      <div class="add-invoice-left-icon">
        <div class="add-invoice-left-icon-container">
          <img src="assets/icons/icon_invoice_upload.svg" class="add-invoice-left-icon-img" />
          <border-spinner *ngIf="isLoading"></border-spinner>
        </div>
      </div>
      <div class="add-invoice-left-text">
        <ng-container *ngIf="isLoading">
          <ol class="add-invoice-left-text-list">
            <li
              class="add-invoice-left-text-list-item"
              [ngClass]="{
                'add-invoice-left-text-list-item-active': isConvertingInvoice,
                'add-invoice-left-text-list-item-skip-count': skipControl.value
              }"
            >
              {{ "CONVERTING_INTO_IMAGE_FILE" | translate }}
            </li>
            <ng-container *ngIf="!skipControl.value">
              <li class="add-invoice-left-text-list-item" [ngClass]="{ 'add-invoice-left-text-list-item-active': isExtractingInvoice }">
                <span>
                  {{ "EXTRACTING_INVOICE_INFORMATION" | translate }}
                  <span *ngIf="isExtractingInvoice">...</span>
                </span>
              </li>
              <li class="add-invoice-left-text-list-item" [ngClass]="{ 'add-invoice-left-text-list-item-active': isClassifyingInvoice }">
                <span>
                  {{ "CLASSIFYING_LINE_ITEMS" | translate }}
                  <span *ngIf="isClassifyingInvoice">...</span>
                </span>
              </li>
            </ng-container>
          </ol>
        </ng-container>

        <ng-container *ngIf="!isLoading">
          <h3 class="add-invoice-left-text-header">
            {{ "DOCUMENT_TYPE.FREIGHT_USER_INVOICE" | translate }}
            <span class="add-invoice-left-text-header-required">{{ "LABELS.REQUIRED" | translate }}</span>
          </h3>

          <ol class="add-invoice-left-text-list">
            <li
              [ngClass]="{
                'add-invoice-left-text-list-item': isWithOcr,
                'add-invoice-left-text-list-item-skip-count': !isWithOcr
              }"
            >
              {{ "ES_ADD_INVOICE_STEP_1" | translate }}
            </li>
            <li *ngIf="isWithOcr" class="add-invoice-left-text-list-item">
              {{ "ES_ADD_INVOICE_STEP_2" | translate }}
            </li>
          </ol>

          <div *ngIf="isWithOcr" class="add-invoice-left-text-checkbox">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" [formControl]="skipControl" class="custom-control-input" id="skipOCRCheckbox" />
              <label class="custom-control-label" for="skipOCRCheckbox">{{ "UPLOAD_INVOICE_WITHOUT_SCANNING" | translate }}</label>
            </div>
          </div>

          <div class="add-invoice-left-text-warning" *ngIf="isShowWarning">
            <div class="add-invoice-left-text-warning-left">
              <div class="add-invoice-left-text-warning-icon">
                <img alt="attention" src="assets/icons/icon_attention_sm.svg" class="add-invoice-left-text-warning-icon-img" />
              </div>
              <div class="add-invoice-left-text-warning-text">
                {{ "EXTRACT_DETAILS_FROM_INVOICE_FAILED" | translate }}
              </div>
            </div>

            <div class="add-invoice-left-text-warning-right">
              <button type="button" class="add-invoice-left-text-warning-btn" (click)="editManually.emit(invoiceId)">
                <span class="add-invoice-left-text-warning-btn-inner">
                  <span class="add-invoice-left-text-warning-btn-pencil"><img src="/assets/icons/icon_pencil_gray.svg" /></span>
                  <span>{{ "EDIT_MANUALLY" | translate }}</span>
                </span>
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="add-invoice-right">
      <document-upload-ocr
        [id]="documentUploadOcrId"
        hint="OCR_FORMATS_HINT"
        [existingFile]="existingFile"
        (upload)="onUploadFile($event)"
      ></document-upload-ocr>

      <div class="add-invoice-right-is-loading" *ngIf="isLoading"></div>
    </div>
  </div>
</div>
